import { UserException } from './user-exception.js';
export function exception(component, code) {
    const { message, solution } = code;
    if (solution) {
        return UserException(component, message, solution);
    }
    return UserException(component, message);
}
